<template>
  <div>
    <el-row class="text-center system-stepcon">
      <el-col :span="14" :offset="5">
        <el-form ref="form" label-width="150px">
          <!-- 通用业务排队策略设置 -->
          <el-form-item size="mini" class="text-left system-stepcon-itemtitle" label="业务通用排队策略设置"></el-form-item>
          <el-form-item size="medium" class="text-left system-stepcon-itemswitch" label="VIP排队优先">
            <el-switch v-model="cacheAcd.comSysAcdBizQueue.enableVipFirst" @input="forceInput" @change="changeEnableVipFirst" :active-value= 1 :inactive-value= 0  active-color="#337eff" inactive-color="#dcdfe6" :width="50"></el-switch>
          </el-form-item>
          <el-form-item size="medium" v-show="showVipFirstType===1" class="text-left" label="VIP优先方式">
            <el-select style="width:160px;" class="pull-left" @change="changeVipIntervalNum" @input="forceInput" v-model="cacheAcd.comSysAcdBizQueue.vipFirstType" placeholder="请选择VIP优先方式">
              <el-option label="永远优先" :value="0"></el-option>
              <el-option label="VIP/普通用户轮流" :value="1"></el-option>
            </el-select>
            <span v-show="showVipIntervalNum===1">
              <span class="pull-left" style="margin:0 10px 0 20px;">每</span>
              <el-input-number style="width:80px;" class="pull-left" v-model="cacheAcd.comSysAcdBizQueue.vipIntervalNum" controls-position="right" @input="forceInput" :min="1" :max="10"></el-input-number>
              <div class="system-stepcon-itemci system-mr10">个</div>
              <span class="pull-left">VIP用户接入1个普通用户</span>
            </span>
          </el-form-item>
          <el-form-item size="medium" label="排队数量播报时间间隔" class="text-left system-stepcon-itemlist">
            <el-input-number style="width:100px;" class="system-mr10" v-model="cacheAcd.comSysAcdBizQueue.reportTimeInterval" controls-position="right" @input="forceInput" :min="1" :max="99999"></el-input-number>
            <span>秒</span>
          </el-form-item>
          <el-form-item size="medium" class="text-left system-stepcon-itemswitch" label="等待时间溢出策略">
            <el-switch v-model="cacheAcd.comSysAcdBizQueue.enableWaittingOverflow" @input="forceInput" :active-value= 1 :inactive-value= 0 active-color="#337eff" inactive-color="#dcdfe6" :width="50"></el-switch>
          </el-form-item>
          <div v-show="cacheAcd.comSysAcdBizQueue.enableWaittingOverflow===1">
            <el-form-item size="medium" label="等待时间溢出阈值" class="text-left system-stepcon-itemlist">
              <el-input-number style="width:100px;" class="system-mr10" v-model="cacheAcd.comSysAcdBizQueue.waitTimeThreshold" controls-position="right" @input="forceInput" :min="1" :max="99999"></el-input-number>
              <span>秒</span>
            </el-form-item>
            <el-form-item size="medium" class="text-left" label="溢出接待技能组">
              <el-select v-model="cacheAcd.comSysAcdBizQueue.skillGroupIds" @input="forceInput" multiple collapse-tags placeholder="请选择">
                <el-option
                  v-for="item in storeSkillGroupList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                  >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <!-- 业务专属排队策略设置 -->
          <el-form-item size="mini" v-show="showBizGroup()" style="margin-top:35px;" class="text-lef system-stepcon-itemtitle" label="业务专属排队策略设置"></el-form-item>
            <div v-for="(bizGroup,index) in cacheAcd.sysAcdBizGroups" :key="index">
              <el-form-item size="medium" :label="'专属排队策略'+(index+1)" class="text-left system-stepcon-itemlist">
                <el-select v-model="bizGroup.bizIds" multiple collapse-tags placeholder="请选择">
                  <el-option
                    v-for="(item,index_) in cacheAcd.acdBizs"
                    :key="index_"
                    :label="item.bizName"
                    :value="item.id"
                    >
                  </el-option>
                </el-select>
                <el-button class="system-ml10" type="info" @click="showDialogExclusive(bizGroup)">专属策略设置</el-button>
                <el-button style="margin-left:10px;" size="medium" @click="deleteGroup(index)" icon="el-icon-minus"></el-button>
              </el-form-item>
            </div>

            <el-dialog class="dialogExclusive" title="专属策略设置" :visible.sync="dialogExclusive" width="560px" center>
              <el-form ref="form" :model="dialogExclusiveForm" label-width="150px">
                <el-form-item size="medium" class="text-left system-stepcon-itemswitch" label="VIP排队优先">
                  <el-switch v-model="dialogExclusiveForm.enableVipFirst" @change="_changeEnableVipFirst" :active-value= 1 :inactive-value= 0  active-color="#337eff" inactive-color="#dcdfe6" :width="50"></el-switch>
                </el-form-item>
                <el-form-item size="medium" v-show="showVipFirstType_===1" class="text-left" label="VIP优先方式">
                  <el-select style="width:160px;" class="pull-left" @change="_changeVipIntervalNum" v-model="dialogExclusiveForm.vipFirstType" placeholder="请选择VIP优先方式">
                    <el-option label="永远优先" :value="0"></el-option>
                    <el-option label="VIP/普通用户轮流" :value="1"></el-option>
                  </el-select>
                    <span v-show="showVipIntervalNum_===1">
                    <span class="pull-left" style="margin:0 10px 0 20px;">每</span>
                    <el-input-number style="width:80px;" class="pull-left" v-model="dialogExclusiveForm.vipIntervalNum" controls-position="right" @input="forceInput" :min="1" :max="10"></el-input-number>
                    <div class="system-stepcon-itemci system-mr10">个</div>
                    <span class="pull-left text-danger system-bfb">VIP用户接入1个普通用户</span>
                  </span>
                </el-form-item>
                <el-form-item size="medium" label="排队数量播报时间间隔" class="text-left system-stepcon-itemlist">
                  <el-input-number class="system-mr10" v-model="dialogExclusiveForm.reportTimeInterval"  controls-position="right" @input="forceInput" style="width:100px" :min="1" :max="99999"></el-input-number>
                  <span>秒</span>
                </el-form-item>
                <el-form-item size="medium" class="text-left system-stepcon-itemswitch" label="等待时间溢出策略">
                  <el-switch v-model="dialogExclusiveForm.enableWaittingOverflow" @change="_changeEnableWaittingOverflow" :active-value= 1 :inactive-value= 0  active-color="#337eff" inactive-color="#dcdfe6" :width="50"></el-switch>
                </el-form-item>
                <div v-show="showWaittingOverflow_===1">
                  <el-form-item size="medium" label="等待时间溢出阈值" class="text-left system-stepcon-itemlist">
                    <el-input-number  class="system-mr10" v-model="dialogExclusiveForm.waitTimeThreshold"  controls-position="right" @input="forceInput"  style="width:100px" :min="1" :max="99999"></el-input-number>
                    <span>秒</span>
                  </el-form-item>
                  <el-form-item size="medium" class="text-left" label="溢出接待技能组">
                    <el-select v-model="dialogExclusiveForm.skillGroupIds" multiple collapse-tags placeholder="请选择">
                      <el-option
                        v-for="item in storeSkillGroupList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-form>
              <span slot="footer" class="dialog-footer">
                <el-button @click="dialogExclusive = false">取 消</el-button>
                <el-button type="primary" @click="confirmCusQueue()">确 认</el-button>
              </span>
            </el-dialog>

          <el-form-item v-show="showBizGroup()" class="text-left system-stepcon-itemlist system-mb20">
            <el-button size="medium" @click="addBizGroup" icon="el-icon-plus" class="system-stepcon-itemlistbtn"></el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row class="text-center system-stepbtn">
    <el-button @click="cancel" class="customer-mr20" size="medium">取 消</el-button>
    <el-button @click="lastStep" size="medium">上一步</el-button>
    <el-button size="medium" v-if="cacheCanEditAcd" @click="save" type="primary">保存</el-button>
    </el-row>
  </div>
</template>
<script>
import { getRandomUUID, saveAcd } from '@/api/user'
export default {
  name: 'stepThree',
  data() {
    return {
      curBizGroupId: '',
      dialogExclusive: false,
      showVipIntervalNum: 0,
      showVipFirstType: 0,
      showVipIntervalNum_: 0,
      showVipFirstType_: 0,
      showWaittingOverflow_: 0,
      dialogExclusiveFormClear: {
        enableVipFirst: 0,
        vipFirstType: 0,
        vipIntervalNum: 1,
        reportTimeInterval: 60,
        enableWaittingOverflow: 0,
        waitTimeThreshold: 300,
        skillGroupIds: []
      },
      dialogExclusiveForm: {
        enableVipFirst: 0,
        vipFirstType: 0,
        vipIntervalNum: 1,
        reportTimeInterval: 60,
        enableWaittingOverflow: 0,
        waitTimeThreshold: 300,
        skillGroupIds: []
      },
      blankBizGroup: {
        id: '',
        type: 1,
        groupOrder: 0,
        acdId: '',
        sysAcdBizQueue: {
          id: '',
          acdId: '',
          bizGroupId: '',
          bizOrder: 0,
          type: 1,
          enableVipFirst: 0,
          vipFirstType: 0,
          vipIntervalNum: 1,
          reportTimeInterval: 60,
          enableWaittingOverflow: 0,
          waitTimeThreshold: 300,
          skillGroupIds: null
        },
        bizIds: [],
        acdBizs: []
      }
    }
  },
  computed: {
    storeSkillGroupList() {
      return this.$store.state.user.skillGroupList
    },
    cacheAcd() {
      return this.$store.state.user.acdCache
    },
    cacheCanEditAcd() {
      return this.$store.state.user.canEditAcd
    }
  },
  methods: {
    forceInput() {
      this.$forceUpdate()// 强制刷新视图，每一个无法输入的input框都需要使用该方法
    },
    _changeEnableVipFirst(data) {
      this.showVipFirstType_ = data
    },
    _changeVipIntervalNum(data) {
      this.showVipIntervalNum_ = data
    },
    _changeEnableWaittingOverflow(data) {
      this.showWaittingOverflow_ = data
    },
    changeEnableVipFirst(data) {
      this.showVipFirstType = data
    },
    changeVipIntervalNum(data) {
      this.showVipIntervalNum = data
    },
    showBizGroup() {
      return this.cacheAcd.enableBiz === 1 && this.cacheAcd.acdBizs && this.cacheAcd.acdBizs.length > 0
    },
    showDialogExclusive(bizGroup) {
      // console.log(bizGroup.sysAcdBizQueue)
      Object.assign(this.dialogExclusiveForm, this.dialogExclusiveFormClear)// 属性置空
      Object.assign(this.dialogExclusiveForm, bizGroup.sysAcdBizQueue)// 拷贝属性
      this.showVipFirstType_ = bizGroup.sysAcdBizQueue.enableVipFirst
      this.showVipIntervalNum_ = bizGroup.sysAcdBizQueue.vipFirstType
      this.showWaittingOverflow_ = bizGroup.sysAcdBizQueue.enableWaittingOverflow

      this.curBizGroupId = bizGroup.id
      this.dialogExclusive = true
    },
    addBizGroup() {
      const random = Math.ceil(Math.random() * 10000000)
      getRandomUUID({ random: random }).then(res => {
        if (res.code === 2000) {
          this.showVipIntervalNum_ = 0
          this.showVipFirstType_ = 0
          this.showWaittingOverflow_ = 0
          const newRandomId = res.data
          const newGroup = JSON.parse(JSON.stringify(this.blankBizGroup))
          newGroup.id = newRandomId
          this.cacheAcd.sysAcdBizGroups.push(newGroup)
          this.forceInput()
        }
      })
    },
    deleteGroup(index) {
      this.cacheAcd.sysAcdBizGroups.splice(index, 1)
      this.forceInput()
    },
    confirmCusQueue() {
      this.dialogExclusive = false
      for (let i = 0; i < this.cacheAcd.sysAcdBizGroups.length; i++) {
        if (this.cacheAcd.sysAcdBizGroups[i].id === this.curBizGroupId) {
          Object.assign(this.cacheAcd.sysAcdBizGroups[i].sysAcdBizQueue, this.dialogExclusiveForm)
          break
        }
      }
    },
    save() {
      saveAcd({ acd: this.cacheAcd }).then(res => {
        if (res.code === 2000) {
          this.$message.success(res.data)
          // 清空acd缓存
          this.$store.commit('user/setAcdCache', { acd: {} })
          this.$store.commit('user/setAcdStepIndex', { acdStepIndex: 1 })
          this.$store.commit('user/setAcdPageIndex', { acdPageIndex: 1 })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    cancel() {
      this.$store.commit('user/setAcdPageIndex', { acdPageIndex: 1 })
      this.$store.commit('user/setAcdStepIndex', { acdStepIndex: 1 })
    },
    lastStep() {
      this.$store.commit('user/setAcdStepIndex', { acdStepIndex: 2 })
    }
  }
}
</script>
